var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"design_form"},[_c('p',{staticClass:"design_form_title"},[_vm._v(_vm._s(_vm.property.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }